import React, { PropsWithChildren } from 'react';

import { useStyletron } from 'baseui';

import { Modal, SIZE } from 'baseui/modal';
import { TechemTheme } from '@techem/techem-theme';
import Icon, { ICONSIZE } from '../Icon';

import xIconWhite from '../../assets/icons/png/3x/icn-nein_1@3x-weiss.png';
import xIconRed from '../../assets/icons/png/3x/icn-nein_1@3x-rot.png';
import { useMediaQuery } from '../../../tools/hooks/useMediaQuery';
import { useModalTracking } from '../../../tools/hooks/useModalTracking';
import { TrackerUtil } from 'tracking/TrackerUtil';

interface Props {
  isOpen: boolean;
  modalId?: string;
  onClose: () => void;
  additionalTestId?: string;
}

const CustomModal: React.FC<PropsWithChildren<Props>> = ({
  children,
  isOpen,
  modalId,
  onClose,
  additionalTestId
}) => {
  const [css] = useStyletron();
  const isMobile = useMediaQuery('(max-width: 992px)');
  useModalTracking(isOpen, `${modalId}`);

  return (
    <Modal
      onClose={() => {
        TrackerUtil.trackBtnClickByIdentifier('close', modalId);
        onClose();
      }}
      isOpen={isOpen}
      animate
      autoFocus={false}
      size={SIZE.auto}
      overrides={{
        Root: {
          style: { zIndex: 10000 },
          props: {
            'data-gi': `modal${additionalTestId !== undefined ? ' ' + additionalTestId : ''}`
          }
        },
        Dialog: {
          style: {
            maxWidth: '100vw',
            width: '972px',
            borderRadius: '8px',
            margin: '30px',
            '@media (max-width: 992px)': {
              width: 'calc(100vw - 20px)',
              margin: '10px'
            }
          }
        },
        Close: {
          style: () => ({ display: 'none' })
        }
      }}
    >
      <div
        className={
          css({
            height: '40px',
            width: '40px',
            top: '-20px',
            right: '-20px',
            backgroundColor: TechemTheme.colors.primary,
            borderRadius: '100%',
            '@media (max-width: 992px)': {
              top: '10px',
              right: '10px',
              backgroundColor: 'inherit'
            }
          }) + ' position-absolute'
        }
      >
        <div className="h-100">
          <Icon
            centered
            iconSrc={isMobile ? xIconRed : xIconWhite}
            handleClick={() => {
              TrackerUtil.trackBtnClickByIdentifier('close', modalId);
              onClose();
            }}
            size={isMobile ? ICONSIZE.default : ICONSIZE.mini}
            alt="close icon"
          />
        </div>
      </div>
      {children}
    </Modal>
  );
};

export default CustomModal;
